import React from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {useIsSaveFraming} from '../../../../priceWatch/hooks/useIsSaveFraming'
import {myListMessages} from '../../../../priceWatch/myListMessages'
import {StyledListItem} from '../commonStyles'
interface Props {
  onClick: () => void
}
export const Alerts = ({onClick}: Props) => {
  const saveFramingIsOn = useIsSaveFraming()

  return (
    <StyledListItem
      as="button"
      hasDivider
      onClick={onClick}
      prefix={<Icon name={saveFramingIsOn ? 'Heart' : 'Bell'} />}
      title={
        <Text variant="labelM">
          {saveFramingIsOn ? (
            <FormattedMessageWrapper {...myListMessages.tabLabel} />
          ) : (
            <FormattedMessageWrapper
              id="priceAlertTabLink"
              defaultMessage="Alerts"
            />
          )}
        </Text>
      }
      suffix={<Icon name="ChevronRight" hasMirror />}
    />
  )
}
